import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons/faStar";

/**
 * Star icon for the rating.
 * @returns Empty star icon.
 */
const EmptyStar = () => <FontAwesomeIcon icon={faStar} size="lg" />;

export default EmptyStar;
